import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import AgentDetails from './agent_view_details/AgentDetails'
import classNames from 'classnames'
import OAppointments from 'components/reusable/OAppointments'
import OPropertyListing from 'components/reusable/OPropertyListing'

const tabBtnClass =
  'inline-block py-3 px-8 text-md xl:text-lg font-semibold border-b-2'
const tabActiveClass = 'border-lime-500 text-lime-500'
const tabBorderNoneClass = 'border-transparent'
const TAB_AGENT_DETAILS = 'agent_details'
const TAB_PROPERTY_DETAILS = 'property_details'
const TAB_APPOINTMENT_DETAILS = 'appointment_details'
function AgentViewPage () {
  const { t } = useTranslation()
  const location = useLocation()
  const [item] = useState(location?.state?.item)

  const [defaultTab, setDefaultTab] = useState('agent_details')
  const handleTabClick = (action, e) => {
    setDefaultTab(action)
  }

  return (
    <>
      <div className='pb-3'>
        <ul className='border-b flex'>
          <li className='mr-0 xl:mr-5'>
            <button
              onClick={handleTabClick.bind(this, TAB_AGENT_DETAILS)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_AGENT_DETAILS,
                [tabBorderNoneClass]: defaultTab !== TAB_AGENT_DETAILS
              })}
            >
              {t('O_AGENT_DETAILS')}
            </button>
          </li>
          <li className='mx-0 xl:mx-5'>
            <button
              onClick={handleTabClick.bind(this, TAB_PROPERTY_DETAILS)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_PROPERTY_DETAILS,
                [tabBorderNoneClass]: defaultTab !== TAB_PROPERTY_DETAILS
              })}
            >
              {t('O_PROPERTY_DETAILS')}
            </button>
          </li>
          <li className='mx-0 xl:mx-5'>
            <button
              onClick={handleTabClick.bind(this, TAB_APPOINTMENT_DETAILS)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_APPOINTMENT_DETAILS,
                [tabBorderNoneClass]: defaultTab !== TAB_APPOINTMENT_DETAILS
              })}
            >
              {t('O_APPOINTMENT_DETAILS')}
            </button>
          </li>
        </ul>
      </div>
      {defaultTab === TAB_AGENT_DETAILS && <AgentDetails item={item} />}
      {defaultTab === TAB_PROPERTY_DETAILS && (
        <OPropertyListing agentId={item?._id} />
      )}
      {defaultTab === TAB_APPOINTMENT_DETAILS && (
        <OAppointments agentId={item?._id} />
      )}
    </>
  )
}

export default AgentViewPage
